export const HELP_COPY = {
  BUTTON: "Besoin d'aide ?",
  TITLE: "Besoin d'aide ?",
  MESSAGE: "Une question sur votre accès ? Écrivez-nous, nous vous répondons au plus vite.",
  SUPPORT_EMAIL: "tickets@yeati.co",
  PRIVACY_EMAIL: "rgpd@yeati.co",
  SUPPORT_LABEL: "Support",
  PRIVACY_LABEL: "Données personnelles",
} as const;
